import { Close as CloseIcon } from '@arvesta-websites/icons';
import * as React from 'react';
import { useIntl } from 'react-intl';
import type { BoxProps } from 'rebass';

import type { LocaleType, NavItemType } from '../../../../../types';
import { withErrorBoundary } from '../../../ErrorBoundary';
import { LangSwitcherLight } from '../../LangSwitcher';
import { SecondaryNavigationMobileItemLight } from '../../SecondaryNavigationMobileItem';

import {
  StyledCloseButton,
  StyledMobileLanguageSelect,
  StyledSecondaryNavigationMobile,
  StyledSelectText,
} from './Styled';

type SubnavItem = NavItemType & {
  open: boolean;
};

interface Props extends BoxProps {
  items: Array<NavItemType>;
  activeMenuUrl: string;
  onClose: () => void;
  defaultLocale: LocaleType;
  activeLocales: Array<string>;
}

const addOpenPropertyToItems = (items: Array<NavItemType>, activeMenuUrl: string): Array<SubnavItem> =>
  items.map((item: NavItemType) => ({
    ...item,
    open: activeMenuUrl === item.to,
  }));

const updateOpenStateOnMenu = (clickedItem: SubnavItem, items: Array<SubnavItem>): Array<SubnavItem> =>
  items.map((item: SubnavItem) => {
    if (clickedItem.to === item.to && item.open === true) {
      return {
        ...item,
        open: false,
      };
    }
    return {
      ...item,
      open: clickedItem.to === item.to,
    };
  });

const SecondaryNavigationMobile = ({ items, activeMenuUrl, onClose, defaultLocale, activeLocales }: Props) => {
  const intl = useIntl();
  const [menuItems, updateMenuItems] = React.useState(addOpenPropertyToItems(items, activeMenuUrl));

  return (
    <>
      <StyledCloseButton onClick={() => onClose()}>
        <span>
          <CloseIcon />
        </span>
      </StyledCloseButton>
      <StyledSecondaryNavigationMobile>
        {menuItems.map((item: SubnavItem) => {
          return (
            <SecondaryNavigationMobileItemLight
              activeMenuUrl={activeMenuUrl}
              item={item}
              key={item.to}
              onClickItem={clickedItem => {
                updateMenuItems(updateOpenStateOnMenu(clickedItem as SubnavItem, menuItems));
              }}
              onClose={() => onClose()}
              open={item.open}
            />
          );
        })}
      </StyledSecondaryNavigationMobile>
      {activeLocales.length > 1 && (
        <StyledMobileLanguageSelect>
          <StyledSelectText>{intl.formatMessage({ id: 'header.selectlanguage' })}</StyledSelectText>
          <LangSwitcherLight activeLocales={activeLocales} defaultLocale={defaultLocale.id} openUpwards />
        </StyledMobileLanguageSelect>
      )}
    </>
  );
};

export default withErrorBoundary(SecondaryNavigationMobile, { componentName: 'SecondaryNavigationMobileLight' });
